import React, { useEffect, useState } from "react";
import { Row, Col, Spin, Card, Button, Input, Tabs, Table, Modal, Space, Tag } from "antd";
import POSLogo from "../../../../../assets/images/NewLogoCW.svg";
import LockIcon from "../../../../../assets/images/lock-icon.svg";
import userIcon from "../../../../../assets/images/userId.svg";
import Online from "../../../../../assets/images/green.svg";
import Offline from "../../../../../assets/images/red.svg";
import BackIcon from "../../../../../assets/images/backIcon.svg";
import SearchIcon from "../../../../../assets/images/searchIcon.svg";
import db from "../../../../../database";
import {
  PrinterOutlined,
  UserOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  CreditCardOutlined,
  CalendarOutlined,
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  CloseOutlined,
  LoadingOutlined,
  CloseSquareFilled,
  RightOutlined,
  DownOutlined,
  EditOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  AppstoreOutlined,
  CodeSandboxOutlined,
  RedoOutlined,
  WarningOutlined,
  CarOutlined,
  GiftOutlined,
  ReloadOutlined,
  ArrowsAltOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { useHistory } from "react-router-dom";
import _, { set } from "lodash";
import Scrollbars from "react-custom-scrollbars";

const RestaurantPreorder = (props) => {
  const {
    loading,
    setLoading,
    searchOrderHistory,
    orderHistoryDetails,
    setOrderHistoryDetails,
    getSalesHistoryData,
    tillData,
    selectedDocumentType,
    setSelectedDocumentType,
    selectedSaleType,
    setSelectedSaleType,
    selectedSaleTypeData,
    setSelectedSaleTypeData,
    getFilteredPaymentMethods,
    setShowPayments,
    retrieveLayaway,
    selectLayAwayOrder,
    setKeyValue,
    dateRange,
    setDateRange,
  } = props;
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const history = useHistory();
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}`;
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);

  const errorMessage = (modalTitle, modalContent) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
    });
  };
  function arraysAreEqual(arr1, arr2) {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  }

  useEffect(() => {
    if (orderHistoryDetails.length > 0) {
      const filteredLayawayOrders = orderHistoryDetails.filter((item) => {
        return posConfig?.advanceLayaway === "Y" ? item.layAway === "Y" : item.layAway === "Y" && item.paid === 0;
      });

      const enrichedLayawayOrders = filteredLayawayOrders.map((item) => ({
        ...item,
        type: item.docstatus === "CAN" ? "Cancelled" : "Layaway",
      }));

      if (!arraysAreEqual(enrichedLayawayOrders, orderHistoryDetails)) {
        setOrderHistoryDetails(enrichedLayawayOrders);
      }
    }
  }, [orderHistoryDetails]);

  //   useEffect(() => {
  //     const isOnline = navigator.onLine;

  //     if (isOnline) {
  //       let dateValue = [moment(new Date()), moment(new Date())];
  //       setLoadingDetails(true);
  //       searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true);
  //       // setShowPreOrders(true);
  //       setLoadingDetails(false);
  //     } else {
  //       errorMessage("Sync Failed", "Please check your network connection and try again");
  //     }
  //   }, []);

  const fetchOrders = async () => {
    if (!navigator.onLine) {
      errorMessage("Sync Failed", "Please check your network connection and try again");
      return;
    }

    try {
      setLoadingDetails(true);

      const dateValue = [moment(), moment()];
      await searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoadingDetails(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <Spin spinning={loadingDetails} indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} />}>
      <div style={{ backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%", padding: "10px", overflow: "hidden" }}>
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "8px 12px",
            marginBottom: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <Row align="middle" justify="space-between">
            <Col>
              <Row align="middle" gutter={8}>
                <Col>
                  <img
                    src={BackIcon}
                    style={{ height: "24px", cursor: "pointer" }}
                    onClick={() => {
                      history.push("/pos");
                    }}
                    alt="Back"
                  />
                </Col>
                <Col>
                  <img
                    src={POSLogo}
                    style={{ height: "32px", cursor: "pointer" }}
                    // onClick={onPosClick}
                    alt="POS Logo"
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row align="middle" gutter={8}>
                <Col>
                  <span style={{ fontSize: "12px", color: "#6b7280" }}>{formattedDateTime}</span>
                </Col>
                <Col>
                  <img src={LockIcon} style={{ height: "20px", cursor: "pointer" }} alt="Lock" />
                </Col>
                <Col>
                  <div
                    style={{
                      border: "1px solid #4b5563",
                      borderRadius: "50%",
                      padding: "4px",
                    }}
                  >
                    <img src={userIcon} style={{ height: "20px" }} alt="User" />
                  </div>
                </Col>
                <Col>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontSize: "12px", fontWeight: 500 }}>{JSON.parse(localStorage.getItem("userData")).user}</span>
                    <span style={{ fontSize: "10px", color: "#6b7280" }}>Till ID : {JSON.parse(localStorage.getItem("tillValue"))?.name}</span>
                  </div>
                </Col>
                <Col>
                  <img src={navigator.onLine ? Online : Offline} style={{ height: "20px" }} alt={navigator.onLine ? "Online" : "Offline"} />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <Row gutter={16} style={{ height: "calc(100vh - 80px)" }}>
          <Col span={16} style={{ borderRadius: "5px", height: "100%" }}>
            <Card
              style={{ height: "100%", borderRadius: "10px", padding: "5px" }}
              bodyStyle={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                padding: "16px",
              }}
            >
              <Row gutter={8} align="middle" justify="space-between" style={{ marginBottom: 10 }}>
                <Col flex="auto">
                  <Input
                    placeholder="Search by Order No..."
                    prefix={<img src={SearchIcon} style={{ height: 16 }} alt="Search" />}
                    // onPressEnter={(e) => {
                    //   if (e.target.value !== "") {
                    //     searchOrderHistory("customer", e.target.value, 0, dateRange?.length > 0 ? true : false);
                    //   }
                    // }}
                    onPressEnter={async (e) => {
                      if (e.target.value !== "") {
                        try {
                          setLoadingDetails(true);
                          setSelectedOrderDetails(null);
                          await searchOrderHistory("customer", e.target.value, 0, dateRange?.length > 0 ? true : false);
                        } catch (err) {
                          setSelectedOrderDetails(null);
                          setLoadingDetails(false);
                          console.error("Search failed:", err);
                        } finally {
                          setSelectedOrderDetails(null);
                          setLoadingDetails(false);
                        }
                      } else {
                        try {
                          setLoadingDetails(true);
                          setSelectedOrderDetails(null);
                          await fetchOrders();
                        } catch (err) {
                          setSelectedOrderDetails(null);
                          setLoadingDetails(false);
                          console.error("Search failed:", err);
                        } finally {
                          setSelectedOrderDetails(null);
                          setLoadingDetails(false);
                        }
                      }
                    }}
                    style={{ height: 32, fontSize: 12, borderRadius: 6, width: "97%" }}
                  />
                </Col>
              </Row>

              <Table
                className="sm-restaurant-preorder-table"
                columns={[
                  { title: "Document Number", dataIndex: "documentno", key: "documentno" },
                  { title: "Date", dataIndex: "orderDate", key: "orderDate" },
                  {
                    title: "Customer",
                    key: "customerName",
                    render: (_, record) => record?.customer?.name || "N/",
                  },
                  { title: "Total Amount", dataIndex: "total", key: "total" },
                  {
                    title: "Type",
                    dataIndex: "type",
                    key: "type",
                    width: "20%",
                    filters: [
                      {
                        text: "Layaway",
                        value: "Layaway",
                      },
                      {
                        text: "Return",
                        value: "Return",
                      },
                      {
                        text: "Receipt",
                        value: "Receipt",
                      },
                    ],
                    onFilter: (value, record) => record?.type === value,
                    render: (text, record) => {
                      let colorStyle;
                      switch (record.type) {
                        case "Layaway":
                          colorStyle = { color: "#007BFF" };
                          break;
                        case "Return":
                          colorStyle = { color: "#f0ad4e" };
                          break;
                        case "Receipt":
                          colorStyle = { color: "#28a745" };
                          break;
                        default:
                          colorStyle = {};
                      }

                      return (
                        <div style={{ position: "relative" }}>
                          <span style={colorStyle}>{text}</span>
                          {record.status === "Success" ? (
                            <CheckCircleTwoTone
                              style={{
                                fontSize: "1rem",
                                cursor: "pointer",
                                marginLeft: "1vw",
                                position: "absolute",
                                right: 1,
                                top: "15%",
                              }}
                              twoToneColor="#A4CD38"
                            />
                          ) : (
                            <ExclamationCircleTwoTone
                              style={{
                                fontSize: "1rem",
                                cursor: "pointer",
                                marginLeft: "1vw",
                                position: "absolute",
                                right: 1,
                                top: "15%",
                              }}
                              twoToneColor="red"
                            />
                          )}
                        </div>
                      );
                    },
                  },
                ]}
                style={{
                  width: "100%",
                  overflowY: "auto",
                  border: "none",
                  // fontSize: "1vw",
                  borderRadius: "7px",
                  padding: "0px 7px",
                  // border: "1px solid rgba(146, 144, 152, 0.4)",
                  height: "72.5vh",
                  background: "#fff",
                }}
                dataSource={orderHistoryDetails}
                pagination={false}
                onRow={(record) => ({
                  onClick: async () => {
                    try {
                      setLoadingDetails(true);
                      const details = await getSalesHistoryData(record.sOrderID);
                      setSelectedOrderDetails(details?.[0] || null);
                    } catch (err) {
                      console.error("Failed to fetch order details", err);
                    } finally {
                      setLoadingDetails(false);
                    }
                  },
                })}
              />
            </Card>
          </Col>

          <Col span={8} style={{ height: "100%" }}>
            {selectedOrderDetails ? (
              <Card
                style={{ height: "100%", borderRadius: "10px" }}
                bodyStyle={{ padding: "16px", display: "flex", flexDirection: "column", height: "100%" }}
                title={
                  <Row justify="space-between" align="middle">
                    <Col>
                      <span style={{ fontSize: "14px", fontWeight: 600, color: "#0F0718" }}>Order Details</span>
                    </Col>
                    <Col>
                      <Button icon={<PrinterOutlined />} style={{ height: "28px", width: "28px", borderRadius: "6px" }} />
                    </Col>
                  </Row>
                }
              >
                <>
                  <div style={{ height: "100%", flex: 1, overflowY: "auto", overflowX: "hidden" }}>
                    <Space direction="vertical" size={12} style={{ width: "100%" }}>
                      {/* Header */}
                      <Row justify="space-between" align="middle">
                        <Col>
                          <div style={{ fontSize: "16px", fontWeight: 600, color: "#0F0718" }}>{selectedOrderDetails?.documentno}</div>
                          <div style={{ fontSize: "10px", color: "#6b7280", color: "#0F0718" }}>{selectedOrderDetails?.orderTime}</div>
                        </Col>

                        <Col style={{ textAlign: "right" }}>
                          <div style={{ fontSize: "14px", fontWeight: 600, color: "#0F0718" }}>₹{selectedOrderDetails?.total}</div>

                          {/* <Tag color={selectedOrderDetails.status === "Success" ? "green" : "red"}>{selectedOrderDetails?.status}</Tag> */}
                        </Col>
                      </Row>

                      {/* Customer Info */}
                      <div>
                        <div style={{ fontSize: "1em", fontWeight: 600, marginBottom: 4, color: "#0F0718" }}>Customer Information</div>

                        <Space direction="vertical" size={4} style={{ fontSize: "12px" }}>
                          <Row gutter={8}>
                            <Col>
                              <UserOutlined />
                            </Col>
                            <Col style={{ color: "#0F0718" }}>{selectedOrderDetails?.customer?.name || "N/A"}</Col>
                          </Row>
                          {selectedOrderDetails?.customer?.mobileNo ? (
                            <Row gutter={8}>
                              <Col>
                                <PhoneOutlined />
                              </Col>
                              <Col style={{ fontSize: "10px", color: "#6b7280" }}>{selectedOrderDetails?.customer?.mobileNo || ""}</Col>
                            </Row>
                          ) : null}

                          {selectedOrderDetails?.customer?.mobileNo ? (
                            <Row gutter={8}>
                              <Col>
                                <EnvironmentOutlined />
                              </Col>
                              <Col style={{ fontSize: "10px", color: "#6b7280" }}>{selectedOrderDetails?.customer?.mobileNo || ""}</Col>
                            </Row>
                          ) : null}
                        </Space>
                      </div>

                      {/* Order Items */}
                      <div>
                        <div style={{ fontSize: "12px", fontWeight: 600, marginBottom: 4, fontSize: "1em", color: "#0F0718" }}>Order Items</div>

                        <Space direction="vertical" size={4} style={{ width: "100%" }}>
                          {selectedOrderDetails.items?.map((item, index) => (
                            <Row key={index} justify="space-between">
                              <Col style={{ display: "flex", justifyContent: "center" }}>
                                <span style={{ fontWeight: 500, fontSize: "0.8em", color: "#0F0718" }}>{item.description}</span>
                                <span style={{ color: "#6b7280", marginLeft: 8, fontSize: "0.8em" }}>x{item.qty}</span>
                              </Col>

                              <Col style={{ display: "flex", justifyContent: "center", fontSize: "0.8em", color: "#0F0718" }}>₹{item.nettotal}</Col>
                            </Row>
                          ))}
                        </Space>
                      </div>

                      {/* Summary */}
                      <div style={{ borderTop: "1px solid #d1d5db", paddingTop: 8 }}>
                        <Space direction="vertical" size={4} style={{ width: "100%" }}>
                          <Row justify="space-between" style={{ fontSize: "0.9em" }}>
                            <Col style={{ color: "#0F0718" }}>Subtotal</Col>
                            <Col style={{ color: "#0F0718" }}>₹{selectedOrderDetails?.subTotal}</Col>
                          </Row>

                          <Row justify="space-between" style={{ fontSize: "0.9em" }}>
                            <Col style={{ color: "#0F0718" }}>Tax</Col>
                            <Col style={{ color: "#0F0718" }}>₹{selectedOrderDetails?.tax}</Col>
                          </Row>

                          {selectedOrderDetails.discount > 0 && (
                            <Row justify="space-between" style={{ fontSize: "0.9em" }}>
                              <Col>Discount</Col>
                              <Col>-₹{selectedOrderDetails.discount}</Col>
                            </Row>
                          )}

                          <Row
                            justify="space-between"
                            style={{
                              fontWeight: 600,
                              borderTop: "1px solid #d1d5db",
                              paddingTop: "1.2vh",
                              fontSize: "1em",
                              color: "#0F0718",
                            }}
                          >
                            <Col>Total</Col>
                            <Col>₹{selectedOrderDetails.total}</Col>
                          </Row>
                        </Space>
                      </div>

                      {/* Payment Info */}
                      <div>
                        <Space direction="vertical" size={4} style={{ width: "100%" }}>
                          {selectedOrderDetails.paymentData?.map((payment, index) => (
                            <Row key={index} style={{ color: "#0F0718" }} justify="space-between">
                              <Col>
                                <CreditCardOutlined /> {payment.name}
                              </Col>
                              <Col>₹{payment.amount}</Col>
                            </Row>
                          ))}
                        </Space>
                      </div>
                    </Space>
                  </div>
                  <div
                    style={{
                      marginTop: "12px",
                      paddingTop: "12px",
                      borderTop: "1px solid #e5e7eb",
                    }}
                  >
                    <Button
                      block
                      style={{
                        height: "40px",
                        borderRadius: "8px",
                        fontWeight: 600,
                        backgroundColor: "#2F3856",
                        color: "white",
                        marginBottom: "7vh",
                      }}
                      onClick={async () => {
                        const detail = {
                          ...selectedOrderDetails,
                          docType: "Invoice",
                          type: "Layaway",
                          preOrder: "Y",
                          layAway: "Y",
                          isPreOrderPage: true,
                          wasLayaway: true,
                          isAdvance: "Y",
                          finishLayaway: false,
                          statusType: "layAway",
                        };
                        selectLayAwayOrder(detail, true);
                        setSelectedDocumentType("Invoice");
                        // setExpandedRowKeys([]);
                        // setSearchhistoryInput("");
                        const saleData = await db.posSaletypes.toArray();
                        saleData.map((item) => {
                          if (item.cwrSaletype.cwrSaletypeId === detail.saleType.cwrSaletypeId) {
                            setSelectedSaleTypeData(item);
                            localStorage.setItem("saleTypeData", JSON.stringify(item));
                            setSelectedSaleType(item?.cwrSaletype?.name);
                          }
                        });
                        let paymentDetails = getFilteredPaymentMethods(detail?.saleType?.cwrSaletypeId || null);
                        let payments =
                          paymentDetails.length > 5
                            ? _.sortBy(paymentDetails, "sequenceNo").slice(
                                0,
                                tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === detail?.customer?.cwrCustomerId && paymentDetails.length === 5 ? 4 : 4
                              )
                            : paymentDetails;
                        // setStartIndex(payments.length);
                        setShowPayments(payments);
                        localStorage.setItem("isRetrieve", "Y");
                        setKeyValue("2");
                        history.push("/pos");
                      }}
                    >
                      Retrieve
                    </Button>
                  </div>
                </>
              </Card>
            ) : (
              <Card
                style={{ height: "100%", borderRadius: "10px" }}
                bodyStyle={{
                  display: "flex",
                  justifyContent: "center",
                  height: "100%",
                  fontSize: "12px",
                  color: "#6b7280",
                  marginTop: "2vh",
                }}
              >
                Click on any order to view details
              </Card>
            )}
          </Col>
        </Row>
      </div>
    </Spin>
  );
};

export default RestaurantPreorder;
